import ChannelAdaptationsCard from "./ChannelAdaptationCard";

export default ChannelAdaptationsCard;
